import { CryptoService } from '@/utils/cryptoService';
import { useAuthStore } from '@/store/useAuthStore';

/** TTL auth token cho `/file/static/` (ms). */
const STATIC_FILE_AUTH_TTL_MS = 15 * 60 * 1000;

/**
 * Gắn `shared` (AES của `userId:expired`) cho URL chứa `/file/static/`.
 * BE giải mã — hợp lệ và chưa hết hạn mới cho xem file.
 * Tái sử dụng ở mọi chỗ gán href/preview/download file static.
 */
export function appendStaticFileAuthParams(url: string): string {
  const raw = String(url || '').trim();
  if (!raw.includes('/file/static/')) return raw;

  const userId = String(useAuthStore.getState().profile?.id || '').trim();
  if (!userId) return raw;

  const expired = Date.now() + STATIC_FILE_AUTH_TTL_MS;
  let authToken = '';
  try {
    authToken = CryptoService.encryptAES(`${userId}:${expired}`);
  } catch {
    return raw;
  }
  if (!authToken) return raw;

  try {
    const isAbsolute = /^https?:\/\//i.test(raw);
    const parsed = isAbsolute
      ? new URL(raw)
      : new URL(raw, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    parsed.searchParams.set('shared', authToken);
    // Request <img>/<a> không kèm header Authorization — BE cần token để gọi SDK lấy quyền/cơ cấu của viewer.
    const accessToken = useAuthStore.getState().accessToken;
    if (accessToken) parsed.searchParams.set('access_token', accessToken);
    parsed.searchParams.delete('expired');
    if (isAbsolute) return parsed.toString();
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    const sep = raw.includes('?') ? '&' : '?';
    const accessToken = useAuthStore.getState().accessToken;
    const tokenParam = accessToken ? `&access_token=${encodeURIComponent(accessToken)}` : '';
    return `${raw}${sep}shared=${encodeURIComponent(authToken)}${tokenParam}`;
  }
}
